module.exports = __webpack_public_path__ + "static/img/IMG_0407.1aa5cae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/news/IMG_0407.jpg
// module id = 0hT6
// module chunks = 1